import {Component, Input, OnInit, OnChanges, OnDestroy, SimpleChanges, Output, EventEmitter, ViewChild, ViewChildren, QueryList} from '@angular/core';
import {Infringement} from '../../../intefaces/infringement.interface';
import { InfringementDTO } from '../../../intefaces/infringementDTO.interface';
import {FormBuilder, FormsModule, FormGroup} from '@angular/forms';
import {MatStep, MatStepper, MatStepperModule} from '@angular/material/stepper';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatListModule} from '@angular/material/list';
import {CommonModule} from '@angular/common';
import {BrowserModule} from '@angular/platform-browser';
import {ReactiveFormsModule} from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material/core';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatDialog, MatDialogModule} from '@angular/material/dialog';
import {Subject} from 'rxjs';
import {switchMap, takeUntil, first, tap} from 'rxjs/operators';
import {timer} from 'rxjs';
import {InfringementService} from '../../../services/infringement.service';
import {Router} from '@angular/router';
import {StatusMessageService} from '../../../services/status-message.service';
import {InfringementWarningEmailDialogComponent} from './infringement-warning-email-dialog.component';
import {UploadProgressDialogComponent} from './upload-progress-dialog.component';
import {ConfirmDialogComponent} from '../../confirm-dialog/confirm-dialog.component';
import {MatchedMailsComponent} from '../matched-mails/matched-mails.component';

@Component({
  selector: 'app-infringement-details-contract-breach',
  standalone: true,
  templateUrl: './infringement-details-contract-breach.component.html',
  styleUrl: './infringement-details-contract-breach.component.scss',
  imports: [
    MatButtonModule,
    MatStepperModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    MatCheckboxModule,
    MatListModule,
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    MatchedMailsComponent
  ],
})

export class InfringementDetailsContractBreachComponent implements OnInit, OnChanges, OnDestroy {
  infringementDetails!: FormGroup;
  genericComments!: FormGroup;
  selectedFileName: string = '';
  isWarningSending: boolean = false;
  isReminderSending: boolean = false;

  private readonly destroy$ = new Subject<void>();

  @ViewChild('stepper') stepper!: MatStepper;
  @ViewChildren(MatStep) steps!: QueryList<MatStep>;

  constructor(
    private fb: FormBuilder,
    private infringementService: InfringementService,
    private router: Router,
    private statusMessage: StatusMessageService,
    private dialog: MatDialog
  ) {
  }

  @Input()
  infringement!: Infringement;

  @Output() refreshData: EventEmitter<void> = new EventEmitter();

  isLinear = true;

  ngOnInit(): void {
    this.infringementDetails = this.fb.group({
      accusedName: this.infringement.accused.name,
      accusedURL: this.infringement.accused.url,
      accusedCountry: this.infringement.accused.country,
      accusedAddress: this.infringement.accused.address,
      accusedEmail: this.infringement.accused.email,
      externalLawyer: this.infringement.externalLawyer,
      responsibleEmployee: this.infringement.responsibleEmployee,
      infringementDetails: this.infringement.infringementDetails,
    });

    this.genericComments = this.fb.group({
      genericComment: "",
    })
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['infringement'] && !changes['infringement'].firstChange && this.stepper) {
      const targetIndex = this.infringement.infringementStatus;

      // Mark all steps before the target as completed
      this.steps.forEach((step: MatStep, index: number) => {
        if (index < targetIndex) {
          step.completed = true;
        }
      });

      // Now advance the stepper to the correct index
      this.stepper.selectedIndex = targetIndex;
    }
  }

  onSubmit() { 
    var dto: InfringementDTO = this.infringementService.infringementToDTO(this.infringement)

    dto.accused.name =  this.infringementDetails.controls['accusedName'].value
    dto.accused.url =  this.infringementDetails.controls['accusedURL'].value
    dto.accused.country =  this.infringementDetails.controls['accusedCountry'].value
    dto.accused.address =  this.infringementDetails.controls['accusedAddress'].value
    dto.accused.email =  this.infringementDetails.controls['accusedEmail'].value
    dto.externalLawyer =  this.infringementDetails.controls['externalLawyer'].value
    dto.responsibleEmployee =  this.infringementDetails.controls['responsibleEmployee'].value
    dto.infringementDetails =  this.infringementDetails.controls['infringementDetails'].value

    this.infringementService.update(dto).subscribe({
      next: (data)=> {
        this.refreshData.emit()
      },
      error: (error) => {
        this.statusMessage.showStatusMessage("Infringement could not be updated", "error")
      }
    })
  }

  addComment(): void {
    if (this.genericComments.valid) {
      const commentText = this.genericComments.value.genericComment;
      // Call the service to post the comment
      this.infringementService.addComment(commentText, this.infringement.identifier).subscribe({
        next: (data) => {
          console.log(data)
          this.genericComments.reset({genericComment: ''});
          this.refreshData.emit();
        },
        error: (error) => {
          this.statusMessage.showStatusMessage("Comment could not be added!", "error");
        }
      });
    }
  }

  async onFileSelected(event: any): Promise<void> {
      const file: File = event.target.files[0];
      if (!file) return;

      this.selectedFileName = file.name;

      const dialogRef = this.dialog.open(UploadProgressDialogComponent, {
        data: { fileName: file.name },
        disableClose: true,
        width: '400px'
      });

      const dialogInstance = dialogRef.componentInstance;
      dialogInstance.startProgress();

      try {
        await this.infringementService.uploadFile(
          file,
          file.name,
          this.infringement.identifier,
          (percent, loaded, total) => dialogInstance.setUploadProgress(percent, loaded, total),
          dialogInstance.signal,
          () => dialogInstance.setConfirming()
        );
        dialogInstance.setCompleted();
        setTimeout(() => dialogRef.close('done'), 600);
        this.refreshData.emit();
      } catch (error: any) {
        if (error?.message === 'Upload cancelled') {
          return;
        }
        const message = error?.message?.includes('expired')
          ? 'Upload took too long. Please try again.'
          : 'Attachment upload failed!';
        dialogInstance.setError(message);
        setTimeout(() => dialogRef.close('error'), 2000);
        this.statusMessage.showStatusMessage(message, 'error');
      }
    }


  async downloadFile(filename: string) {
    try {
      await this.infringementService.downloadFile(filename, this.infringement.identifier);
    } catch (error) {
      this.statusMessage.showStatusMessage("Attachment could not be downloaded", "error");
    }
  }

  deleteattachment(filename: string) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Delete Attachment',
        message: `Are you sure you want to delete "${filename}"?`
      },
      width: '400px'
    });

    dialogRef.afterClosed().subscribe(confirmed => {
      if (!confirmed) return;
      this.infringementService.deleteFile(filename, this.infringement.identifier).subscribe({
        next: (data) => {
          this.refreshData.emit();
        },
        error: (error) => {
          this.statusMessage.showStatusMessage("Attachment could not be deleted!", "error");
        }
      });
    });
  }

  openWarningEmailDialog(): void {
    this.infringementService.getTemplateText(this.infringement.identifier).subscribe({
      next: (template) => {
        const attachments = Array.isArray(this.infringement.attachments)
          ? this.infringement.attachments
          : [];
        const dialogRef = this.dialog.open(InfringementWarningEmailDialogComponent, {
          data: {
            infringementId: this.infringement.identifier,
            recipient: this.infringement.accused.email,
            sender: "legal@tecalliance.net",
            template: template,
            attachments,
            dialogTitle: 'Warning Email'
          },
          disableClose: true,
          width: '75vw',
          maxWidth: '75vw'
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result === true) {
            this.isWarningSending = true;
            this.pollUntilStatusAdvanced(this.infringement.infringementStatus, () => {
              this.isWarningSending = false;
            });
          } else if (result === 'already_sent') {
            this.refreshData.emit();
          }
        });
      },
      error: () => {
        this.statusMessage.showStatusMessage('Template could not be loaded!', 'error');
      }
    });
  }

  openReminderEmailDialog(): void {
    this.infringementService.getTemplateText(this.infringement.identifier).subscribe({
      next: (template) => {
        const attachments = Array.isArray(this.infringement.attachments)
          ? this.infringement.attachments
          : [];
        const dialogRef = this.dialog.open(InfringementWarningEmailDialogComponent, {
          data: {
            infringementId: this.infringement.identifier,
            recipient: this.infringement.accused.email,
            sender: "legal@tecalliance.net",
            template: template,
            attachments,
            dialogTitle: 'Reminder Email'
          },
          disableClose: true,
          width: '75vw',
          maxWidth: '75vw'
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result === true) {
            this.isReminderSending = true;
            this.pollUntilStatusAdvanced(this.infringement.infringementStatus, () => {
              this.isReminderSending = false;
            });
          } else if (result === 'already_sent') {
            this.refreshData.emit();
          }
        });
      },
      error: () => {
        this.statusMessage.showStatusMessage('Reminder template could not be loaded!', 'error');
      }
    });
  }

  private pollUntilStatusAdvanced(previousStatus: number, onComplete: () => void): void {
    const maxAttempts = 5;
    const intervalMs = 500;
    let attempts = 0;

    timer(intervalMs, intervalMs).pipe(
      takeUntil(this.destroy$),
      tap(() => attempts++),
      switchMap(() => this.infringementService.getInfringement(this.infringement.identifier)),
      first(data => data.infringementStatus !== previousStatus || attempts >= maxAttempts)
    ).subscribe({
      next: () => {
        this.refreshData.emit();
        onComplete();
      },
      error: () => {
        this.refreshData.emit();
        onComplete();
      }
    });
  }
}
